<template>
    <button :name="name" type="submit" :id="_id" :required="_required" :class="sizeClass">
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
    import {useAbstractFormInput} from '@/composables/abstractFormInput';
    import {usePortuna} from '@/composables/portuna';
    import {FormRowKey} from '@/library/form';
    import {computed, inject, toRefs} from 'vue';

    const portuna = usePortuna();

    const props = withDefaults(
        defineProps<{
            id?: string;
            name: string;
            required?: boolean;
            size?: string;
        }>(),
        {
            required: false,
            size: 'none',
        },
    );

    const {
              id,
              name,
              required,
          } = toRefs(props);

    const parentFormRow = inject<Nullable<IFormRowContext>>(FormRowKey, null);

    const {
              _id,
              _required,
              triggerFocus,
          } = useAbstractFormInput(
        parentFormRow,
        id,
        required,
    );

    const sizeClass = computed(() =>
    {
        return ('none' !== props.size && props.size) || '';
    });

    defineExpose(Object.assign({}, portuna, {
        componentName: 'FormInput',
        triggerFocus,
    }));
</script>